/**
 * When incrementing or decrementing an array index in a loop, get the proper index accounting for less than 0 or greater than the last index
 * @param index
 * @param length
 */
export var normalizeIndex = function normalizeIndex(index, length) {
  if (index < 0) return length + index;
  if (index > length - 1) return index - length;
  return index;
};